<template>
  <span>
    <button @click="decrease">-</button>
    <span class="stakeInput">
    <input ref="input"
           v-bind:value="value"
           v-on:input="updateValue($event.target.value)"
           v-on:focus="selectAll"
           v-on:blur="formatValue">
    </span>
    <button @click="increase">+</button>
  </span>
</template>

<script>
  var currencyValidator = {
    format: function (number) {
      if (number < 0) {
        number = 0
      }
      var val = (Math.trunc(number * 1000000000000) / 1000000000000).toFixed(2)
      val = Number(val).toString()
      if (val === '0') {
        val = ''
      }
//      val = val.split('.').join(',')
      console.log(number + ' formated to: ' + val)
      return val
    },
    parse: function (newString, oldNumber) {
      console.log('newString: ' + newString)
      console.log('oldNumber: ' + oldNumber)
      var CleanParse = function (value) {
        return {value: value}
      }
      var CurrencyWarning = function (warning, value) {
        return {
          warning: warning,
          value: value,
          attempt: newString
        }
      }
      var NotAValidDollarAmountWarning = function (value) {
        return new CurrencyWarning(newString + ' is not a valid dollar amount', value)
      }
      var AutomaticConversionWarning = function (value) {
        return new CurrencyWarning(newString + ' was automatically converted to ' + value, value)
      }

      var newNumber = Number(newString)
      if (newNumber < 0) {
        newNumber = 0
      }
      if (newNumber > 100) {
        newNumber = 100
      }
      var indexOfDot = newString.indexOf('.')
      var indexOfE = newString.indexOf('e')

      if (isNaN(newNumber)) {
        if (
          indexOfDot === -1 &&
          indexOfE > 0 &&
          indexOfE === newString.length - 1 &&
          Number(newString.slice(0, indexOfE)) !== 0
        ) {
          return new CleanParse(oldNumber)
        } else {
          return new NotAValidDollarAmountWarning(oldNumber)
        }
      }

      var newCurrencyString = currencyValidator.format(newNumber)
      var newCurrencyNumber = Number(newCurrencyString)

      if (newCurrencyNumber === newNumber) {
        if (indexOfE !== -1 && indexOfE === newString.length - 2) {
          return new AutomaticConversionWarning(newNumber)
        } else {
          return new CleanParse(newNumber)
        }
      } else {
        return new NotAValidDollarAmountWarning(
          newNumber > newCurrencyNumber
            ? newCurrencyNumber
            : oldNumber
        )
      }
    }
  }

  export default {
    props: {
      value: {
        type: Number
      },
      label: {
        type: String,
        default: ''
      }
    },

    methods: {
      increase (selection) {
        this.updateModel(1)
      },
      decrease (selection) {
        var d = -1
        if (this.value <= 1) {
          d = this.value * -1
        }
        this.updateModel(d)
      },
      updateModel (v) {
        var self = this
        this.$emit('updateStake', v)
        setTimeout(function () {
          self.formatValue()
        }, 0)
      },
      updateValue: function (value) {
        console.log('updateValue: ' + value)
        var result = currencyValidator.parse(value, this.value)
        if (result.warning) {
          this.$refs.input.value = result.value
        }
        this.$emit('input', result.value)
//        this.$emit('updateStake', result.value)
      },
      formatValue: function () {
        this.$refs.input.value = currencyValidator.format(this.value)
      },
      selectAll: function (event) {
        /*
        // Workaround for Safari bug
        // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
        setTimeout(function () {
          event.target.select()
        }, 0)
        */
      }
    },

    mounted: function () {
      this.formatValue()
    },

    computed: {},

    watch: {}
  }
</script>

<style scoped>
  .stakeInput {
    position: relative;
    margin-left: -6px;
  }
.stakeInput input {
  width: 50px;
  padding-left: 10px;
  text-align: right;
}
.stakeInput:before {
  content: "€";
  z-index: 1;
  position: relative;
  left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/sports/betslip/stakeInput.vue